import * as React from 'react';
import Tooltip from 'components/tooltip';
import ItemsSelector from 'components/items_selector/items_selector';
import Form from 'components/form';
import { Page, Subscriber } from 'resources/types';
import UnsubscribeConfirmationModal from './unsubscribe_confirmation_modal';
import notify, { Method } from 'utils/notify';
import Heading from './heading';

declare global {
  interface Window {
    Routes: any;
    analyticsClient: any; // this is needed so TS doesn't whine about analyticsClient
  }
}

const tooltipTitle = (subscriber: Subscriber, page: Page): string =>
  `This page allows you to fine-tune which components matter to you. You will receive ${Subscriber.displayMode(
    subscriber,
  )} notifications when ${
    page.name
  } is having an issue that affects any of the selected components.`;

interface ManageSubscriptionProps {
  page: Page;
  subscriber: Subscriber;
  components: any[];
  selectedComponentIds: string[];
  allowComponentSubscribers: boolean;
  use_adg3: any;
  analyticsPayload: string;
}

const unsubscribe = (page: Page, subscriber: Subscriber): void => {
  $('#modal-confirmation-confirmationModalId').modal();
};

const onConfirmUnsubscribe = (page: Page, subscriber: Subscriber): void => {
  $.ajax({
    url: `/unsubscribe/${subscriber.id}.json`,
    type: 'DELETE',
    dataType: 'json',

    complete: response => {
      notify('You have been unsubscribed!', { method: Method.DEFERRED });
      window.location.href = window.location.origin;
    },
    error: error => {
      notify(
        'You could not be unsubscribed. Contact support if this problem persists.',
        { method: Method.SHOW },
      );
      console.error('Failed to unsubscribe subscriber.', error);
    },
  });
};
const ManageSubscriptionLegacy: React.FunctionComponent<
  ManageSubscriptionProps
> = ({
  page,
  subscriber,
  components,
  selectedComponentIds,
  allowComponentSubscribers,
  use_adg3,
  analyticsPayload,
}) => {
  return (
    <div>
      <Heading
        subscriber={subscriber}
        onUnsubscribe={() => unsubscribe(page, subscriber)}
      />

      <ComponentForm
        page={page}
        subscriber={subscriber}
        components={components}
        selectedComponentIds={selectedComponentIds}
        allowComponentSubscribers={allowComponentSubscribers}
        use_adg3={use_adg3}
        analyticsPayload={analyticsPayload}
      />

      <UnsubscribeConfirmationModal
        page={page}
        subscriber={subscriber}
        onConfirm={() => onConfirmUnsubscribe(page, subscriber)}
      />
    </div>
  );
};

const ComponentForm: React.FunctionComponent<ManageSubscriptionProps> = ({
  subscriber,
  page,
  components,
  selectedComponentIds,
  allowComponentSubscribers,
  use_adg3,
  analyticsPayload,
}) => {
  if (!allowComponentSubscribers) {
    return null;
  }

  const route = window.Routes.manage_subscription_legacy_path(subscriber.id);

  const onSubmit = () => {
    window.analyticsClient.then((analyticsClient: any) => {
      analyticsClient.sendUIEvent(JSON.parse(analyticsPayload));
    });
  };

  return (
    <Form action={route} method="PATCH">
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>
          <strong>Components</strong>{' '}
          <small>
            (
            <a
              style={{ cursor: 'pointer' }}
              data-js-hook="toggle-all"
              id="component-selector-toggle"
              tabIndex={0}
            >
              Toggle all
            </a>
            )
          </small>
        </span>

        <Tooltip title={tooltipTitle(subscriber, page)}>
          <small>What's this?</small>
        </Tooltip>
      </div>

      <ItemsSelector
        className="inline"
        items={components}
        preselectedItemIds={selectedComponentIds}
        showHeader={false}
        showFooter={false}
        hiddenFieldName="subscriber[component_ids]"
        toggleAllclickTargetId="component-selector-toggle"
        showTooltipDescriptions={true}
        use_adg3={use_adg3}
      />

      <div className="form-actions">
        <button className="flat-button" type="submit" onClick={onSubmit}>
          Update Preferences
        </button>
      </div>
    </Form>
  );
};

export default ManageSubscriptionLegacy;
